import { FC } from 'react'
import { KudosDto } from '../../../types'
import { PerModal } from '../Modal'
import PerFlexRow from '../FlexRow'
import PerText from '../Text'
import { useDateTime } from '../../../shared/useDateTime'
import { useAuth } from '../../../context/auth-context'
import { NameDisplayPreference } from '../../../graphql/enum/name-display-preference.enum'
import { PerAvatarPlus } from '../AvatarPlus'
import PerIcon from '../Icon'
import { useTranslation } from 'react-i18next'
import { getKudosColor } from '../../../shared/kudosUtil'

export interface AttentionPointDetailsModalProps {
  visible: boolean
  onClose: () => void
  attentionPoint: KudosDto
}

export const AttentionPointDetailsModal: FC<AttentionPointDetailsModalProps> = ({ visible, onClose, attentionPoint }) => {
  const { user } = useAuth()
  const { t } = useTranslation()

  const { formatDateShort } = useDateTime(user)

  return (
    <PerModal
      title={{
        heading: t('attentionPoint.detailsModal.title'),
      }}
      size="medium"
      centered
      visible={visible}
      onCancel={onClose}
      footer={{
        confirmBtn: {
          onClick: onClose,
          altText: t('attentionPoint.detailsModal.closeButtonText'),
        },
      }}
    >
      <PerFlexRow direction="column">
        {attentionPoint.author && attentionPoint.employee && (
          <PerFlexRow align="bottom">
            {/* From Section */}
            <div style={{ maxWidth: '44%' }}>
              <PerFlexRow direction="column" justify="start" mr="xxl">
                <PerText fontSize="s" color="secondary" mb="xxxs">
                  {t('global.from')}
                </PerText>
                {attentionPoint.authorId === user.employeeId && <div style={{ marginBottom: '2.5px' }}></div>}
                <PerAvatarPlus
                  firstName={attentionPoint.author.firstName}
                  lastName={attentionPoint.author.lastName}
                  nameDisplayPreference={user.nameDisplayPreference as NameDisplayPreference}
                  infoText={attentionPoint.author.companyName}
                  nameType={attentionPoint.authorId === user.employeeId ? 'you' : 'fullName'}
                />
                {attentionPoint.authorId === user.employeeId && <div style={{ marginBottom: '2.5px' }}></div>}
              </PerFlexRow>
            </div>

            {/* Arrow Section */}
            <div style={{ width: '12%', marginBottom: '2px' }}>
              <PerIcon name="arrowRight_stroke" size={18} color={getKudosColor(attentionPoint.type)} />
            </div>

            {/* To Section */}
            <div style={{ maxWidth: '44%' }}>
              <PerFlexRow direction="column" justify="start">
                <PerText fontSize="s" color="secondary" mb="xxxs">
                  {t('global.to')}
                </PerText>
                {attentionPoint.employeeId === user.employeeId && <div style={{ marginBottom: '2.5px' }}></div>}
                <PerAvatarPlus
                  firstName={attentionPoint.employee.firstName}
                  lastName={attentionPoint.employee.lastName}
                  nameDisplayPreference={user.nameDisplayPreference as NameDisplayPreference}
                  infoText={attentionPoint.employee.companyName}
                  nameType={attentionPoint.employeeId === user.employeeId ? 'you' : 'fullName'}
                />
                {attentionPoint.employeeId === user.employeeId && <div style={{ marginBottom: '2.5px' }}></div>}
              </PerFlexRow>
            </div>
          </PerFlexRow>
        )}

        <PerText fontSize="s" color="secondary" mt="l" mb="xxs">
          {formatDateShort(attentionPoint.createdDate)}
        </PerText>
        <div style={{ minHeight: '100px' }}>
          <PerText>"{attentionPoint.description}"</PerText>
        </div>
      </PerFlexRow>
    </PerModal>
  )
}

export default AttentionPointDetailsModal
